import { Building, Filter, TrendingUp, FileBarChart, Database, MapPin } from "lucide-react";

const POINTS = [
  {
    icon: Building,
    title: "Real Estate Marketing Specialists",
    desc: "We don't service every industry — we go deep on real estate. That focus shows in every campaign we run.",
    testid: "why-specialists",
  },
  {
    icon: Filter,
    title: "Qualified Lead Generation",
    desc: "Pre-filtered leads with budget, location & intent matched — not just form fills, but actual buyers.",
    testid: "why-qualified-leads",
  },
  {
    icon: TrendingUp,
    title: "Better ROI",
    desc: "Lower cost per qualified lead through continuous optimisation, smart targeting, and creative testing.",
    testid: "why-better-roi",
  },
  {
    icon: FileBarChart,
    title: "Transparent Reporting",
    desc: "Daily dashboards, weekly reviews, monthly deep-dives. You always know what's working — and why.",
    testid: "why-transparent",
  },
  {
    icon: Database,
    title: "Data-Driven Campaigns",
    desc: "Every decision is backed by analytics — from creative direction to bid strategy to audience segments.",
    testid: "why-data-driven",
  },
  {
    icon: MapPin,
    title: "Local Market Expertise",
    desc: "Deep understanding of Pune micro-markets — Hinjewadi, Wakad, Kharadi, Baner, Pune West and more.",
    testid: "why-local-expertise",
  },
];

export const WhyChoose = () => {
  return (
    <section data-testid="why-choose-section" className="section-pad bg-surface">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange mb-3">
              Why Digital Hights
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy leading-tight tracking-tight">
              Not a generic agency. A real estate growth partner.
            </h2>
            <p className="mt-4 text-base text-slate-600">
              We measure ourselves by site visits booked and units sold — not impressions or vanity metrics.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
            {POINTS.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.testid}
                  data-testid={p.testid}
                  className="bg-white border border-slate-200 rounded-2xl p-6 hover:border-orange transition-colors group"
                >
                  <div className="w-11 h-11 rounded-xl bg-navy text-white flex items-center justify-center mb-4 group-hover:bg-orange transition-colors">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-bold text-navy text-base mb-1.5">{p.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
